import React from "react";
import { withAuthenticator } from "aws-amplify-react";
import LoginForm from "./LoginForm";
import "./amplify";

export const withAuth = (comp) =>
  withAuthenticator(comp, false, [<LoginForm />]);
